import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageSquareIcon, MapPinIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, SMS_HREF } from '../lib/contact';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-bark" data-id="element-101" data-mp="9luxafjjzvqk">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:py-24" data-id="element-102" data-mp="4lysie31809y">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-103" data-mp="12860zz2gicrl">
          <span className="inline-flex items-center gap-2 font-stamp text-xs uppercase tracking-[0.25em] text-oak-light" data-id="element-104" data-mp="sartioyigybf">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-105" data-mp="nbexpepnwgwp" />
            Made in Santa Barbara, California
          </span>
          <h1 className="mt-4 font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl" data-id="element-106" data-mp="3d2tln1u126au">
            Handcrafted trash cans, born from real wine barrels.
          </h1>
          <p className="mt-5 max-w-lg font-body text-lg leading-relaxed text-parchment/80" data-id="element-107" data-mp="3j925rpk1dsw2">
            Each piece is built by hand from retired oak wine barrels — forged
            horseshoe pulls, hammered steel bands, and a burned-in brand. One of a
            kind, and made to last a lifetime outdoors or in.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-108" data-mp="3eb91x367hayy">
            <a href={PHONE_HREF} className="inline-flex items-center justify-center gap-2 rounded-sm bg-wine px-6 py-3 font-stamp text-sm uppercase tracking-widest text-cream transition-colors hover:bg-oak" data-id="element-109" data-mp="30ggdtgc92mgr">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-110" data-mp="2violwmblv0ck" />
              Call {PHONE_DISPLAY}
            </a>
            <a href={SMS_HREF} className="inline-flex items-center justify-center gap-2 rounded-sm border-2 border-oak-light px-6 py-3 font-stamp text-sm uppercase tracking-widest text-oak-light transition-colors hover:bg-oak-light hover:text-bark" data-id="element-111" data-mp="2hind8kp3momj">
              <MessageSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-112" data-mp="nat8heoiaqma" />
              Send a Text
            </a>
          </div>
          <p className="mt-4 font-body text-sm italic text-parchment/60" data-id="element-113" data-mp="id02omr47ymj">
            Buy one, rent for your party, or outfit an entire venue.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.15
      }} className="relative" data-id="element-114" data-mp="1b15ntam2zpmw">
          <div className="h-[390px] overflow-hidden rounded-sm border-4 border-oak-dark shadow-2xl sm:h-[500px] lg:h-[470px]" data-id="element-115" data-mp="111ewfhsthqr1">
            <img src="https://cdn.magicpatterns.com/uploads/m8LVTeePNWaDzRgCVU2Dws/ChatGPT_Image_Jul_18,_2026_at_12_16_28_AM.png" alt="Handmade wine barrel trash can with a horseshoe handle, rope pull, and hammered steel bands" className="h-full w-full object-cover object-[center_62%]" data-id="element-116" data-mp="x37ewkqj4les" />
          </div>
          <div className="absolute -bottom-4 -left-4 hidden rotate-[-4deg] border-2 border-oak-dark bg-cream px-4 py-2 font-stamp text-xs uppercase tracking-widest text-wine shadow-lg sm:block" data-id="element-117" data-mp="21bxz17cvkwce">
            No two alike
          </div>
        </motion.div>
      </div>
    </section>;
}